export const getTokensFromCurrencyPair = (currencyPair: string) => {
  const pair = currencyPair ?? "";

  if (!pair) return [];

  return pair.split("/");
};
